/**
 * Global Buy Now flow for PageFly + theme add-to-cart buttons:
 * relabel → add to cart → confetti → redirect to checkout (skip cart drawer).
 */
(function () {
  const BUY_NOW_TEXT = 'Buy Now';
  const ADDING_TEXT = 'Adding...';
  const CHECKOUT_URL = '/checkout';
  const CHECKOUT_DELAY_MS = 4400;
  const COLORS = ['#C9A227', '#1B2B4B', '#E67E22', '#F59E0B', '#FFFFFF'];

  const BUTTON_SELECTOR = [
    '[data-pf-type="ProductATC2"]',
    '#addyStickyAtcBtn',
    '.addy-sticky-atc__btn',
    'form[action*="/cart/add"] button[type="submit"]',
    '.product-form__submit',
    'button[name="add"]',
  ].join(',');

  let lastButton = null;
  let checkoutScheduled = false;

  function setBuyNowPending(active) {
    window.__ssBuyNowPending = active;
  }

  function patchCartUi() {
    ['cart-drawer', 'cart-notification'].forEach((tag) => {
      const el = document.querySelector(tag);
      if (!el || el.__ssBuyNowPatched) return;
      el.__ssBuyNowPatched = true;

      if (typeof el.open === 'function') {
        const originalOpen = el.open.bind(el);
        el.open = function patchedOpen() {
          if (window.__ssBuyNowPending) return;
          return originalOpen.apply(this, arguments);
        };
      }

      if (typeof el.renderContents === 'function') {
        const originalRender = el.renderContents.bind(el);
        el.renderContents = function patchedRender() {
          if (window.__ssBuyNowPending) return;
          return originalRender.apply(this, arguments);
        };
      }
    });
  }

  function loadConfetti() {
    if (window.confetti) return Promise.resolve(window.confetti);
    if (window.__ssConfettiPromise) return window.__ssConfettiPromise;

    window.__ssConfettiPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.jsdelivr.net/npm/canvas-confetti@1.9.3/dist/confetti.browser.min.js';
      script.async = true;
      script.onload = function () {
        resolve(window.confetti);
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });

    return window.__ssConfettiPromise;
  }

  function burstFromButton(btn) {
    if (!btn) return;

    loadConfetti()
      .then(function (confetti) {
        if (!confetti) return;

        var rect = btn.getBoundingClientRect();
        var x = (rect.left + rect.width / 2) / window.innerWidth;
        var y = (rect.top + rect.height / 2) / window.innerHeight;

        confetti({
          particleCount: 90,
          spread: 75,
          startVelocity: 42,
          origin: { x: x, y: y },
          colors: COLORS,
          ticks: 220,
          gravity: 1.05,
          scalar: 0.95,
          disableForReducedMotion: true,
        });

        window.setTimeout(function () {
          confetti({
            particleCount: 45,
            spread: 110,
            startVelocity: 28,
            origin: { x: x, y: y },
            colors: COLORS,
            ticks: 180,
          });
        }, 140);
      })
      .catch(function () {
        /* Confetti is decorative; checkout still proceeds. */
      });
  }

  function showTrustOverlay() {
    var overlay = document.getElementById('ss-buy-now-trust');
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.id = 'ss-buy-now-trust';
      overlay.className = 'ss-buy-now-trust';
      overlay.setAttribute('role', 'status');
      overlay.setAttribute('aria-live', 'polite');
      overlay.innerHTML =
        '<div class="ss-buy-now-trust__card">' +
        '<div class="ss-buy-now-trust__badge">✓ 60-Day Money-Back Guarantee</div>' +
        '<h2 class="ss-buy-now-trust__title">Buy with confidence!</h2>' +
        '<p class="ss-buy-now-trust__text">If you don\'t like our products for any reason, we\'ll give you a full refund.</p>' +
        '<p class="ss-buy-now-trust__meta">Free U.S. shipping on every order</p>' +
        '</div>';
      document.body.appendChild(overlay);
    }
    overlay.classList.add('is-visible');
  }

  function scheduleCheckout(btn) {
    if (checkoutScheduled) return;
    checkoutScheduled = true;
    setBuyNowPending(true);

    const source = btn || lastButton;
    showTrustOverlay();
    burstFromButton(source);

    window.setTimeout(function () {
      window.location.href = CHECKOUT_URL;
    }, CHECKOUT_DELAY_MS);
  }

  function setButtonLabel(btn, text) {
    const label = btn.querySelector('b, span') || btn;
    label.textContent = text;
  }

  function relabelButton(btn) {
    if (!btn || btn.dataset.ssBuyNowLabeled === '1') return;
    if (btn.closest('[data-ss-buy-now-skip]')) return;

    btn.dataset.ssBuyNowLabeled = '1';

    if (btn.hasAttribute('data-adding')) {
      btn.setAttribute('data-adding', ADDING_TEXT);
    }

    if (!btn.dataset.ssBuyNowOriginal) {
      const label = btn.querySelector('b, span') || btn;
      btn.dataset.ssBuyNowOriginal = label.textContent.trim();
    }

    if (!btn.classList.contains('loading') && !btn.disabled) {
      setButtonLabel(btn, BUY_NOW_TEXT);
    }
  }

  function watchPageFlySuccess(btn) {
    if (!btn || btn.dataset.ssBuyNowWatch === '1') return;
    btn.dataset.ssBuyNowWatch = '1';

    const successText = (btn.getAttribute('data-added') || 'Thank you!').trim();
    let lastText = btn.textContent.trim();

    const observer = new MutationObserver(function () {
      const current = btn.textContent.trim();
      if (current === lastText) return;

      if (current === successText && window.__ssBuyNowPending) {
        scheduleCheckout(btn);
      }

      if (
        btn.dataset.ssBuyNowLabeled === '1' &&
        current !== successText &&
        current !== ADDING_TEXT &&
        current !== BUY_NOW_TEXT &&
        btn.dataset.ssBuyNowOriginal &&
        current === btn.dataset.ssBuyNowOriginal
      ) {
        setButtonLabel(btn, BUY_NOW_TEXT);
      }

      lastText = current;
    });

    observer.observe(btn, { childList: true, subtree: true, characterData: true });
  }

  function initButtons() {
    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (btn) {
      relabelButton(btn);
      watchPageFlySuccess(btn);
    });
    patchCartUi();
  }

  document.addEventListener(
    'click',
    function (event) {
      const btn = event.target.closest(BUTTON_SELECTOR);
      if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

      lastButton = btn;
      checkoutScheduled = false;
      setBuyNowPending(true);

      window.setTimeout(function () {
        if (!checkoutScheduled) setBuyNowPending(false);
      }, 12000);
    },
    true
  );

  document.addEventListener('ss:cart-add-success', function () {
    if (!window.__ssBuyNowPending) return;
    scheduleCheckout(lastButton);
  });

  document.addEventListener(
    'cart:update',
    function (event) {
      if (!window.__ssBuyNowPending) return;
      event.stopImmediatePropagation();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtons);
  } else {
    initButtons();
  }

  const root = document.querySelector('.__pf') || document.body;
  new MutationObserver(initButtons).observe(root, { childList: true, subtree: true });

  window.setInterval(patchCartUi, 1000);
})();
